import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import PaymentForms from "./invoicing/PaymentForms";
import { config } from "@/config";
import LoadingModal from "@/components/LoadingModal";
import { InvoiceData } from "../types/type";
import SenderInfo from "./invoicing/SenderInfo";
import RecipientInfo from "./invoicing/RecipientInfo";
import InvoiceItems from "./invoicing/InvoiceItems";
import Summary from "./invoicing/Summary";
import InvoicePaid from "./invoicePaid";
import InvoiceCancelled from "./invoiceCancelled";
import NoteSection from "./invoicing/noteSection";

export default function Invoicing() {
    const { invoiceId } = useParams<{ invoiceId: string }>();
    const [invoiceData, setInvoiceData] = useState<InvoiceData | null>(null);
    const [formType, setFormType] = useState("")

    useEffect(() => {
        if (invoiceId) {
            getInvoice(invoiceId)
        }
    }, [invoiceId]);

    async function getInvoice(invoiceId: string) {
        const response = await axios.get(`${config.backendUrl}/invoices/${invoiceId}`)
        console.log("invoice", response.data)
        setInvoiceData(response.data)
        initializeFormType(response.data.allowedPaymentMethods)
    }

    function initializeFormType(allowedPaymentMethods: string[]) {
        let defaultPaymentMethod = allowedPaymentMethods[0]
        if (defaultPaymentMethod === 'card') {
            setFormType('card-form')
        } else if (defaultPaymentMethod === 'ach') {
            setFormType('bank-form')
        }
    }

    if (!invoiceData) {
        return <LoadingModal loading={true} />
    }

    return (
        <div className="h-full overflow-y-auto bg-slate-100">
            <div className="container mx-auto max-w-4xl py-6 px-4 sm:px-6 lg:px-8">
                <h1 className="text-xl font-semibold text-gray-900 mb-4">Invoice Details</h1>
                <div className="grid gap-4">
                    <SenderInfo invoiceData={invoiceData} />
                    <RecipientInfo invoiceData={invoiceData} />
                    <InvoiceItems invoiceData={invoiceData} />
                    <NoteSection invoiceData={invoiceData} />
                    <Summary invoiceData={invoiceData} formType={formType} />
                    {invoiceData.status === 'paid' ? (
                        <div className="mt-6">
                            <InvoicePaid />
                        </div>
                    ) : invoiceData.status === 'cancelled' ? (
                        <div className="mt-6">
                            <InvoiceCancelled />
                        </div>
                    ) : (
                        <div className="mt-6">
                            <h1 className="text-xl font-semibold text-gray-900 mb-4">Pay the invoice</h1>
                            <PaymentForms accountId={invoiceData.accountId} formType={formType}
                                setFormType={setFormType} invoiceId={invoiceData.id} getInvoice={getInvoice}
                                allowedPaymentMethods={invoiceData.allowedPaymentMethods || ['card', 'ach']} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}